/** Шаг 2 оформления: количество и комментарий. */
import type {
  CurrentUser,
  PublicProduct,
} from '@arbuz/shared';
import { formatWeight, makeT } from '../../i18n';
import {
  ProductImage,
  QuantityStepper,
} from '../clientUi';

export function StepQuantity({
  user,
  lines,
  products,
  missingCount,
  weight,
  comment,
  onQty,
  onComment,
}: {
  user: CurrentUser;
  lines: { product_id: number; qty: number }[];
  products: Map<number, PublicProduct>;
  missingCount: number;
  weight: { min: number; max: number } | null;
  comment: string;
  onQty: (productId: number, qty: number) => void;
  onComment: (comment: string) => void;
}) {
  const t = makeT(user.locale);

  return (
    <>
      <h1 className="h1">{t('quantityTitle')}</h1>
      <div style={{ display: 'grid', gap: 'var(--s-3)', marginTop: 'var(--s-4)' }}>
        {lines.map((line) => {
          const product = products.get(line.product_id);
          if (!product) return null;
          return (
            <article key={line.product_id} className="client-card client-product-card">
              <ProductImage src={product.image_url} />
              <div>
                <h2 style={{ margin: 0, fontSize: 'var(--fs-h3)' }}>{product.name}</h2>
                {formatWeight(product.weight_min_kg, product.weight_max_kg) && (
                  <p className="muted" style={{ margin: 'var(--s-1) 0 var(--s-3)', fontSize: 'var(--fs-sm)' }}>
                    {formatWeight(product.weight_min_kg, product.weight_max_kg)} {t('kg')}
                  </p>
                )}
                <QuantityStepper qty={line.qty} locale={user.locale} onChange={(qty) => onQty(line.product_id, qty)} />
              </div>
            </article>
          );
        })}
      </div>

      {missingCount > 0 && (
        <div className="client-card" role="alert" style={{ padding: 'var(--s-4)', marginTop: 'var(--s-3)' }}>
          <p style={{ margin: 0, color: 'var(--c-danger)' }}>{t('productUnavailable')}</p>
        </div>
      )}

      <p className="muted" style={{ margin: 'var(--s-5) 0 var(--s-2)' }}>
        {t('approxWeightOne')}
      </p>
      <strong>{weight ? `${weight.min} – ${weight.max} ${t('kg')}` : `— ${t('kg')}`}</strong>

      <div
        className="client-card"
        style={{
          display: 'grid',
          gridTemplateColumns: '62px 1fr',
          gap: 'var(--s-3)',
          alignItems: 'center',
          marginTop: 'var(--s-5)',
          padding: 'var(--s-4)',
          background: 'var(--c-highlight)',
        }}
      >
        <ProductImage style={{ width: 62, height: 62, borderRadius: 'var(--r-lg)' }} />
        <div>
          <p style={{ margin: 0, fontSize: 'var(--fs-sm)' }}>{t('totalApprox')}</p>
          <h2 style={{ margin: 'var(--s-1) 0 0', fontSize: 'var(--fs-h2)' }}>
            {weight ? `${weight.min} – ${weight.max} ${t('kg')}` : `— ${t('kg')}`}
          </h2>
        </div>
      </div>

      <label
        htmlFor="comment"
        style={{ display: 'block', margin: 'var(--s-8) 0 var(--s-2)', fontWeight: 'var(--fw-bold)' }}
      >
        {t('commentLabel')}
      </label>
      <textarea
        id="comment"
        value={comment}
        maxLength={100}
        rows={4}
        placeholder={t('commentPlaceholder')}
        onChange={(event) => onComment(event.target.value)}
        style={{
          width: '100%',
          padding: 'var(--s-4)',
          borderRadius: 'var(--r-lg)',
          border: '1px solid var(--c-border-input)',
          background: 'var(--c-surface)',
          color: 'var(--c-text)',
          font: 'var(--fw-regular) var(--fs-body)/var(--lh-body) var(--font)',
          resize: 'vertical',
        }}
      />
      <p className="muted" style={{ margin: 'var(--s-1) 0 0', fontSize: 'var(--fs-xs)', textAlign: 'right' }}>
        {comment.length}/100
      </p>
    </>
  );
}

